import { Configuration, ProductCategoriesApi } from '@/api';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { useQuery, useQueryClient } from '@tanstack/react-query';

const useGetProductCategoryQuery = (productCategoryId?: string) => {
  const queryClient = useQueryClient();

  const productCategoriesApi = new ProductCategoriesApi(new Configuration(useAuth));

  const {
    isLoading,
    data: productCategory,
    error,
  } = useQuery({
    queryKey: ['productCategory', productCategoryId],
    queryFn: () => {
      return productCategoryId ? productCategoriesApi.getProductCategory(productCategoryId) : null;
    },
    enabled: productCategoryId !== '',
  });

  const invalidateQuery = async () => {
    return queryClient.invalidateQueries({ queryKey: ['productCategory', productCategoryId] });
  };

  return {
    productCategory,
    isLoading,
    error,
    invalidateQuery,
  };
};

export default useGetProductCategoryQuery;
